import { useQuery } from "@tanstack/react-query";
import { http } from "../../../utils";

export async function fetchHospitalMember(searchBy = "", value = "") {
  const { data } = await http(
    `/auth/hospital-member${
      searchBy !== "" && value !== "" ? `?${searchBy}=${value}` : ""
    }`
  );

  return data;
}

export function useHospitalMember() {
  const { data, ...raResult } = useQuery(["hospital-member"], () =>
    fetchHospitalMember()
  );

  return {
    ...raResult,
    data: data ?? {},
  };
}
